import {AbstractModel} from './abstract-model';
import {Offer} from './offer';

export class CustomPayoutOffer extends AbstractModel {
  offer!: Offer;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.offer) {
      this.offer = new Offer().deserialize(input.offer);
    }

    return this;
  }

  override toString(): string {
    return this.offer.toString();
  }
}
